var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-progress',_vm._b({attrs:{"height":"2rem","animated":"","striped":"","variant":_vm.full ? 'success' : 'primary'}},'b-progress',{ max: _vm.max },false),[_c('b-progress-bar',{attrs:{"value":_vm.value}},[(_vm.full)?_c('h5',{staticClass:"my-0"},[_vm._v(_vm._s(_vm.fullText))]):_c('h5',{staticClass:"my-0"},[_vm._v(_vm._s(_vm.fixedValue)+"%")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }